/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, FilterBox} from '../../components';
import { openNotice } from 'Utils';
import { getPromotionList, getPromotionIsEdit } from '../../service/promotion';
import { getDictionay } from '../../service/product';
import {Store, Actions} from './store';
import './promotion.css';
class PromotionList extends Reflux.Component {
	constructor(props) {
		super(props);
		this.store = Reflux.initStore(Store); //创建一个Store实例
		this.state = {
			opts: ['促销管理'],
			key: 0,
			filterBoxVisible: false,
			showHideBtnIndex: 0,
			rows: [],
			total: 1,
			searchObj: {
				code: '',
				subject: '',
				startDate: '',
				endDate: '',
				statusPro: [],
				category: '',
				s: 10,
				p: 1
			},
			categoryArr: []
		};
		this.pageChange = this.pageChange.bind(this);
		this.changeHandle = this.changeHandle.bind(this);
		this.visibleChange = this.visibleChange.bind(this);
		this.setFilterParam = this.setFilterParam.bind(this);
		this.advanceReset = this.advanceReset.bind(this);
		this.advanceSubmit = this.advanceSubmit.bind(this);
		this.routeLeaveHook = this.routeLeaveHook.bind(this);
	}

	goView(url) {
		hashHistory.push(url);
	}

	changeHandle({item, key, keyPath}) {
		this.setState({key});
	}

	visibleChange() {
		this.setState({filterBoxVisible: !this.state.filterBoxVisible});
	}

	advanceReset() {
		let self = this;
		self.setState({
			filterBoxVisible: false,
			searchObj: {
				...this.state.searchObj,
				code: '',
				subject: '',
				startDate: '',
				endDate: '',
				statusPro: [],
				category: ''
			}
		});
	};

	advanceSubmit(form) {
		/* 筛选确认 */
		let self = this;
		this.setState({
			filterBoxVisible: false,
			searchObj: {
				...this.state.searchObj,
				p: 1
			}
		}, function () {
			self.initData();
		});
	};

	setFilterParam(name, value) {
		if (name === 'activityDate') {
			this.setState({
				searchObj: {
					...this.state.searchObj,
					startDate: value.from,
					endDate: value.end
				}
			})
		} else {
			this.setState({ searchObj: { ...this.state.searchObj, [name]: value } })
		}
	};

	pageChange(page, pageSize) {
		/* 翻页 刷新 */
		let self = this;
		this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
			self.initData();
		});
	}

	initData () {
		let self = this;
		let searchObj = self.state.searchObj;
		searchObj.status = searchObj.statusPro.join(',');
		getPromotionList(searchObj).then(function (result) {
			if (result && result.code == 200) {
				self.setState({
					'rows': result.data || [],
					'total': result.total
				});
			} else {
				openNotice('error', '数据获取失败', '');
			}
		});
	}

	//离开当前路由时，更新store
	routeLeaveHook(nextLocation) {
		let path = nextLocation.pathname.split('/');
		if(path[1] === 'promotion'){ //当下一个路由是详情页时，将useStore的值设为true
			Actions.useStoreChange(true);
			Actions.paramChange(this.state.searchObj);
		}else{
			Actions.useStoreChange(false);
			Actions.paramChange({});
		}
	}

	componentWillMount () {
		const data = this.store.state;
		if(data.useStore) { //根据useStore的值判断是否使用store中的数据
			this.setState({
				...this.state,
				searchObj: {
					...this.state.searchObj,
					...data.params
				},
				key: data.params.buyerStatus || 0
			});
		}
	}

	componentDidMount () {
		let self = this;
		getDictionay('promotion_category').then((result) => {
			// 促销活动 数据字典
			if (!result || result.code != 200) {
				return;
			}
			let categoryArr = [];
			for (let item of result.data) {
				categoryArr.push({
					'text': item.name,
					'value': item.sKey
				});
			}
			self.setState({
				categoryArr: categoryArr
			});
		});
		this.initData();
		//设置离开当前路由时的钩子函数
		this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
	}

	showHideBtn (index) {
		this.setState({
			showHideBtnIndex: index
		});
	}

	hideBtn () {
		this.setState({
			showHideBtnIndex: ''
		});
	}

	toEdit ( index ) {
		/* 编辑 */
		let self = this;
		let id = self.state.rows[index].id;
		getPromotionIsEdit(id).then((result) => {
			if (!result || result.code != 200) {
				openNotice('error', '数据获取失败，请重试', '');
				return;
			}
			if (result.data == true) {
				// 用权限编辑
				self.goView('promotion/add/' + this.state.rows[index].id);
			} else {
				openNotice('warning', '该促销不能编辑', '');
			}
		});
	}

	render() {
		const {opts, key, filterBoxVisible, rows, total, searchObj, categoryArr, showHideBtnIndex} = this.state;
		let self = this;
		const filterBoxProps = {
			showFlag: filterBoxVisible,
			advance: {
				fileds: [
					{
						name: 'code',
						label: '编码',
						text: '输入促销编码',
						type: 'default',
						defaultValue: searchObj.code
					},
					{
						name: 'subject',
						label: '主题',
						text: '输入促销主题',
						type: 'default',
						defaultValue: searchObj.subject
					},
					{
						name: 'activityDate',//startCreatedDate, endCreatedDate
						label: '活动日期',
						options: [
							{ text: '开始日期' },
							{ text: '结束日期' },
						],
						type: 'dateComp',
						defaultValue: {
							from: searchObj.startDate || '',
							end: searchObj.endDate || ''
						},
					},
					{
						name: 'statusPro',
						label: '活动状态',
						text: '选择状态',
						options: [
							{value: '', text: '全部'},
							{value: 0, text: '未开始'},
							{value: 1, text: '进行中'},
							{value: 2, text: '已结束'},
							{value: 3, text: '已下架'}
						],
						multiple: true,//支持多选
						type: 'select',
						defaultValue: searchObj.statusPro
					},
					{
						name: 'category',
						label: '类型',
						text: '选择状态',
						options: categoryArr,
						multiple: false,//支持多选
						type: 'select',
						defaultValue: searchObj.category
					}
				],
				handle: this.advanceSubmit,
				reset: this.advanceReset,
				fieldHandle: this.setFilterParam
			}
		};
		const tableViewProps = {
			loading: false,//更新表格数据中
			rowKey: 'id',
			pageParam: {
				total: total,
				current: searchObj.p,//当前页码
				pageSize: searchObj.s,//当前分页数
				onChange: this.pageChange
			},
			columns: [
				{
					title: '促销编码',
					dataIndex: 'code',
					render: (text, record, index) => {
						return <a href={`#/promotion/${record.id}`}>{text}</a>
					}
				}, {
					title: '主题',
					dataIndex: 'subject',
					render: (text, record, index) => {
						let statusRender = function (statusText) {
							if (statusText == '进行中') {
								return <span className="promotion_status promotion_status_red">{statusText}</span>
							} else if (statusText == '未开始') {
								return <span className="promotion_status promotion_status_green">{statusText}</span>
							} else {
								return <span className="promotion_status">{statusText}</span>
							}
						};
						return <div className="bu_s_h">{statusRender(record.statusText)}{text}</div>
					}
				}, {
					title: '分类',
					dataIndex: 'categoryText'
				}, {
					title: '促销时间',
					dataIndex: 'showPrice',
					render: (text, record, index) => {
						return <div className="bu_s_h">
							<div onMouseOver={self.showHideBtn.bind(self, index)} onMouseOut={self.hideBtn.bind(self)} className="event"></div>
							<span>{record.startTime + ' ~ ' + record.endTime}</span>
						</div>
					}
				}, {
					title: '适用范围',
					dataIndex: 'scope',
					render: (text, record, index) => {
						return <div className="bu_s_h">
							<div onMouseOver={self.showHideBtn.bind(self, index)} onMouseOut={self.hideBtn.bind(self)} className="event"></div>
							<span>{text || '全部'}</span>
						</div>
					}
				}, {
					title: '状态',
					dataIndex: 'activeText',
					render: (text, record, index) => {
						return <div className="bu_s_h">
							<div onMouseOver={self.showHideBtn.bind(self, index)} onMouseOut={self.hideBtn.bind(self)} className="event">
								<Button style={{display: (showHideBtnIndex === index && record.modifiable == true) ? 'inline-block' : 'none'}} size={'small'} type="primary" onClick={self.toEdit.bind(self, index)}>编辑</Button>
							</div>
							<span>{text}</span>
						</div>
					}
				}
			],
			rows
		};
		return <div>
			<DmsTab options={opts} defaultKey={key} onChange={this.changeHandle}>
				<Button icon="plus" onClick={this.goView.bind(this, `/promotion/add/0`)}>新增</Button>
				<Button icon="filter" onClick={this.visibleChange}>筛选</Button>
				<FilterBox  {...filterBoxProps}/>
			</DmsTab>
			<div className="dms-table-box">
				<TableView {...tableViewProps}/>
			</div>
		</div>
	}
}
;
export default withRouter(PromotionList);


// WEBPACK FOOTER //
// ./src/routes/promotion/list.js